/**
 * Simple Linear Congruential Generator (LCG) for deterministic pseudo-random numbers
 * Uses the same parameters as Numerical Recipes
 */
export class PRNG {
	private seed: number

	constructor(seed: number = Date.now()) {
		this.seed = seed
	}

	/**
   * Generate next pseudo-random number between 0 and 1
   */
	next(): number {
		this.seed = (this.seed * 1664525 + 1013904223) % 4294967296
		return this.seed / 4294967296
	}

	/**
   * Reset the generator with a new seed
   */
	setSeed(seed: number): void {
		this.seed = seed
	}

	/**
   * Get current seed
   */
	getSeed(): number {
		return this.seed
	}

	/**
   * Shuffle an array using Fisher-Yates algorithm with this PRNG
   */
	shuffle<T>(array: T[]): T[] {
		const shuffled = [...array]
		for (let i = shuffled.length - 1; i > 0; i--) {
			const j = Math.floor(this.next() * (i + 1));
			[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
		}
		return shuffled
	}
}
